import React from 'react'
import { DotLoader } from 'react-spinners';

function BigLoader() {
  return (
    <div className="w-full py-4 px-2 flex-colo h-screen">
      <DotLoader color="#10b981" />
    </div>
  );
}

export default BigLoader;
